import { render } from "./WalletActivationModal.vue?vue&type=template&id=87d73bfe&scoped=true"
import script from "./WalletActivationModal.vue?vue&type=script&lang=js"
export * from "./WalletActivationModal.vue?vue&type=script&lang=js"

import "./WalletActivationModal.vue?vue&type=style&index=0&id=87d73bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d73bfe"]])

export default __exports__